import { AdditionalClientContact, ContactId, PlacementId } from "@sp-crm/core";
import { ContactCardList } from "components/contacts/card/contact-card-list";
import React, { FunctionComponent } from "react";
import Contact from "./contact";

type ContactsListProps = {
    clientId: PlacementId;
    contacts: AdditionalClientContact[];
    editContact: (contactId: ContactId) => void;
    deleteContact: (contactId: ContactId) => void;
};

const ContactsList: FunctionComponent<ContactsListProps> = ({
    contacts,
    clientId,
    editContact,
    deleteContact,
}) => {
    return (
        <ContactCardList>
            {contacts.map((contact: AdditionalClientContact) => (
                <Contact
                    key={contact.id}
                    clientId={clientId}
                    contact={contact}
                    editContact={editContact}
                    deleteContact={deleteContact}
                />
            ))}
        </ContactCardList>
    );
};

export default ContactsList;
